import * as React from 'react';
import Bottom from "./Bottom";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import MainHomeTop from "../components/main/MainHomeTop";
import MainMedical from "../components/main/MainMedical";
import MainCounsel from "../components/main/MainCounsel";
import MainCheck from "../components/main/MainCheck";
import MainChart from "../components/main/MainChart";
import MainCare from "../components/main/MainCare";
import MainOffice from "../components/main/MainOffice";
import {useEffect, useState} from "react";
import api from "../utils/api";
import careStore from "../store/careStore";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import MainResult from '../components/main/MainResult';
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const Home = () => {
  const storeData1: any = careStore();
  const [isVisible, setIsVisible] = useState(false);
  const [dialogContent, setDialogContent] = useState<JSX.Element | null>(null);
  
  const closePopup = () => {
    setIsVisible(false);
  };

  const hideForADay = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    localStorage.setItem("hidePopupUntil", String(tomorrow.getTime()));
    setIsVisible(false);
  };
  
  useEffect(() => {
    const token = window.localStorage.getItem("token");
    const userId: any = localStorage.getItem('userCusID');
    
    /* 로그인이 되어 있고, api 호출 true 일때만 팝업 출력 */
    if (token == null || userId == null) {
    } else {
      api.post(`customer/api/v1/popup`, { familyId: localStorage.getItem('ownerFamID') }).then(res => {
        const isSpecial = res.data.data.isSpecial;
        const companyId = res.data.data.companyId;
        const companyList: string[] =  ['CO#68'];

        //회사별 다이얼로그
        const companyDialogs: Record<string, JSX.Element> = {
          'CO#68': (
              <>
                <p>건강검진 예약 기간은</p>
                <p>2025년 8월 8일 금요일 오후 5시까지입니다.</p>
                <p>마감일 이후 예약은 불가합니다.</p>
                <p>꼭 일정 확인 부탁드리며,</p>
                <p>개인정보( 연락처, 주소 등 ) 확인 부탁드립니다</p>
                <p></p>
                <p>감사합니다.</p>
              </>
          ),
        }
        if (isSpecial || (companyId && companyList.includes(companyId))){
          if (isSpecial) {
            setDialogContent(
                <>
                  <p>{localStorage.getItem('userName')} 님은 {new Date().getFullYear()} 년도 특수 검진 대상자입니다.</p>
                  <p>선택항목에서 반드시 특수검진을 “YES(네)”로 선택해 주십시오.</p>
                </>
            );
          } else if (companyId && companyDialogs[companyId]) {
            setDialogContent(companyDialogs[companyId]);
          }

          // 팝업 표시
          const hideUntil = localStorage.getItem("hidePopupUntil");
          if (!hideUntil || new Date().getTime() > Number(hideUntil)) {
            setIsVisible(true);
          }
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
    
    return () => {
      storeData1.setCareInfo('height', 0);
      storeData1.setCareInfo('weight', 0);
      storeData1.setCareInfo('reset', '');
    }
  }, []);
    
  return (
    <Container sx={{p: '0 !important', bgcolor: '#F6F6F6', pb:'50px !important', minWidth:320}}>
      <MainHomeTop/>
      <Dialog open={isVisible} onClose={closePopup}>
        <DialogTitle>안내</DialogTitle>
        <DialogContent>
          {dialogContent}
        </DialogContent>
        <DialogActions>
          <Button onClick={hideForADay} color="secondary">
            하루 동안 열지 않기
          </Button>
          <Button onClick={closePopup} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Grid item container sx={{p:2 }}>
        <MainMedical/>
        <MainResult/>
        {
          localStorage.getItem('openConsultationReservation') == 'true'
            ? <MainCounsel/> : ''
        }
        <MainCheck />
       
        <MainCare />
        <MainChart />
        <MainOffice />
      </Grid>
      <Bottom />  
    </Container>
  );
}

export default Home;